import {clearInputsByName, fillInputsByName, getInputsByName} from "../../helpers/forms";
import {toUrl} from "../../helpers/url";
import handleAjaxError from "../../helpers/handleAjaxError";
import Axios from "axios";
import {showLoading} from "../../helpers/loading";
import createElement from "../../helpers/createElement";
import {initContractorSelect} from "../../common/contractors/select";
import {setAsSelect2} from "../../helpers/inputs";

let _reloadUrl = window.location;
let eventTypeSelect = null;
let modal = null;
let contractors = null;

let eventFields = [
	'id',
	'project_id',
	'title',
	'type',
	'start_date',
	'end_date',
	'description',
	'contractor_id',
]

const eventTypesContents = {
	'custom': () => {
		return `
			<div class="form-group">
				<label for="name">Description</label>
				<input type="text"
				   class="form-control"
				   name="description"
				   placeholder="Event Description"
				   autocomplete="off">
				<div class="invalid-feedback"></div>
			</div>
		`;
	},
	'contractor': () => {
		return `
			<div class="row">
				<div class="col-6">
					<div class="form-group">
						<label for="name">Description</label>
						<input type="text"
						   class="form-control"
						   name="description"
						   placeholder="Event Description"
						   autocomplete="off">
						<div class="invalid-feedback"></div>
					</div>
				</div>
				<div class="col-6">
					<div class="form-group contractor-select-placeholder">
						<label for="name">Contractor</label>
						<input type="text"
						   class="form-control"
						   name="contractor_id"
						   placeholder="Contractor"
						   autocomplete="off">
						<div class="invalid-feedback"></div>
					</div>
				</div>
			</div>
		`;
	}
}

// Options default values
let onlyContractorsSchedules = false;

function initCalendarCreateEventModal(reloadUrl = null, options = {}) {
	if (reloadUrl)
		_reloadUrl = reloadUrl;

	if (options.onlyContractorsSchedules) {
		onlyContractorsSchedules = true;
	}

	// noinspection JSUnresolvedVariable - Comes from view
	contractors = window.contractors;

	document.querySelector('.calendar-create-event-modal-confirm-button').onclick = saveCalendarEvent;
	modal = document.querySelector('.calendar-create-event-modal');
	eventTypeSelect = document.querySelector('.calendar-create-event-modal select[name=type]');
	eventTypeSelect.onchange = renderModalContent;

	modal.querySelectorAll('select[name=project_id]').forEach(
		select => select.onchange = renderModalContent
	);

	// noinspection JSUnresolvedFunction
	$(modal.querySelector('input[name="start_date"]')).datetimepicker({
		format: 'YYYY-MM-DD',
		icons: {
			time: 'mdi mdi-clock',
			date: 'mdi mdi-calendar-blank',
			up: 'mdi mdi-chevron-up',
			down: 'mdi mdi-chevron-down',
			previous: 'mdi mdi-chevron-left',
			next: 'mdi mdi-chevron-right',
			today: 'mdi mdi-calendar',
			clear: 'mdi mdi-delete',
			close: 'mdi mdi-close'
		}
	});

	// noinspection JSUnresolvedFunction
	$(modal.querySelector('input[name="end_date"]')).datetimepicker({
		format: 'YYYY-MM-DD',
		icons: {
			time: 'mdi mdi-clock',
			date: 'mdi mdi-calendar-blank',
			up: 'mdi mdi-chevron-up',
			down: 'mdi mdi-chevron-down',
			previous: 'mdi mdi-chevron-left',
			next: 'mdi mdi-chevron-right',
			today: 'mdi mdi-calendar',
			clear: 'mdi mdi-delete',
			close: 'mdi mdi-close'
		}
	});

	if (onlyContractorsSchedules) {
		// Remove all options from event type select except contractors
		document.querySelector('select[name=type]').innerHTML = `
			<option value="contractor" selected>Contractor</option>
		`;
	}
}

function renderModalContent() {
	const eventType = eventTypeSelect.value;
	modal.querySelector('.content').innerHTML = eventTypesContents[eventType]();

	if (eventType === 'contractor') {
		// Init contractor select2
		/** @type {HTMLElement} */
		const contractorSelectPlaceholder = modal.querySelector('.contractor-select-placeholder');

		showLoading(contractorSelectPlaceholder);

		const selectedProjectId = getInputsByName(modal, ['project_id']).project_id;

		// Retrieve HTML from server
		Axios.post(window['admin.contractors.get-select-component'], {
			project: selectedProjectId
		}).then(result => {
			// Replace contractor select from HTML from server
			const contractorSelect = createElement(result.data.component);

			contractorSelectPlaceholder.replaceWith(contractorSelect);

			// Prefill if possible
			contractorSelect.querySelector('select').value =
				contractorSelectPlaceholder.querySelector('input').value;

			// Init contractor select
			initContractorSelect(contractorSelect);


		}).catch(handleAjaxError)
	}

	/** @type {HTMLSelectElement} */
	const projectSelect = modal.querySelector('.component-project-select');
	if (projectSelect) {
		setAsSelect2(projectSelect, {
			width: '100%',
			dropdownParent: $(modal),
		});
	}
}

function showCalendarCreateEventModal(event = null) {
	// Set modal title
	modal.querySelector('h5').innerText = 'Create New Calendar Event';

	clearInputsByName(modal, [
		'id',
		'title',
		'start_date',
		'end_date',
		'description',
		'contractor_id',
	])

	// If we have an event we need to first set the field so its rendered correctly...
	if (event) {
		// Set type and project before rendering to render correct fields
		modal.querySelector('select[name="type"]').value = event.extendedProps.type;

		modal.querySelectorAll('select[name="project_id"],input[name="project_id"]').forEach(input => {
			input.value = event.extendedProps.event.project_id;
		})
		// Set modal title
		modal.querySelector('h5').innerText = 'Edit Calendar Event';
	}
	renderModalContent();
	// ...and fill them again, as the render clears them
	if (event) {
		fillInputsByName(modal, event.extendedProps.event)
		// Remove time from date fields
		modal.querySelectorAll('input[name=start_date],input[name=end_date]').forEach(input => {
			input.value = input.value.split(' ')[0];
		})
		// Fill correct type again
		modal.querySelector('select[name=type]').value = event.extendedProps.type;
	}
	$(modal).modal('show');
}

function saveCalendarEvent() {
	const data = getInputsByName(modal, eventFields);

	loading();
	Axios.post(toUrl('/admin/calendar/events'), data)
		.then(response => {
			// noinspection JSUnresolvedVariable
			Swal.fire({
				icon: 'success',
				text: response.data.message,
				timer: 2000
			}).then(() => {
				loading();
				document.location = _reloadUrl;
			})
		})
		.catch(handleAjaxError)
		.finally(stopLoading)
}

export {
	initCalendarCreateEventModal,
	showCalendarCreateEventModal
}
